import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_gjg59xw39x: FaireCollectionEntity = {
  token: "pbc_gjg59xw39x",
  type: "collection",
  name: "30% OFF BOOTS",
  heroImageUrl:
    "https://cdn.faire.com/fastly/72f4636f993d51214c67cce8ce45a5dab1510255718018e5426b793d972dfcbb.jpeg",
  itemCount: 7,
  description:
    "Save 30% off our stunning Fall Boot collection with this limited-time promotion.\nSale ends December 31, 2025!  \nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes\n\n\n\n\n\n",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:31.079Z",
    importedBy: "entity-db-import-collections",
  },
};
